import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

interface ResponsiveLayoutProps {
  children: React.ReactNode;
  mobileLayout?: React.ReactNode;
  className?: string;
}

export const ResponsiveLayout = ({ 
  children, 
  mobileLayout, 
  className 
}: ResponsiveLayoutProps) => {
  const isMobile = useIsMobile();

  if (isMobile && mobileLayout) {
    return (
      <div className={cn('mobile-vh', className)}>
        {mobileLayout}
      </div>
    );
  }

  return (
    <div className={cn('min-h-screen', className)}>
      {children}
    </div>
  );
};

interface ResponsiveGridProps {
  children: React.ReactNode;
  cols?: 1 | 2 | 3 | 4;
  className?: string;
}

export const ResponsiveGrid = ({ 
  children, 
  cols = 2, 
  className 
}: ResponsiveGridProps) => {
  const gridClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
  };

  return (
    <div className={cn(
      'grid gap-4 sm:gap-6',
      gridClasses[cols],
      className
    )}>
      {children}
    </div>
  );
};

interface ResponsiveStackProps {
  children: React.ReactNode;
  spacing?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const ResponsiveStack = ({ 
  children, 
  spacing = 'md', 
  className 
}: ResponsiveStackProps) => {
  const spacingClasses = {
    sm: 'space-y-2 sm:space-y-3',
    md: 'space-y-3 sm:space-y-4 md:space-y-6',
    lg: 'space-y-4 sm:space-y-6 md:space-y-8'
  };

  return (
    <div className={cn(
      'flex flex-col',
      spacingClasses[spacing],
      className
    )}>
      {children}
    </div>
  );
};